

























import { computed, defineComponent, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import emitter from "@/lib/emitter";
import { getLiveUrlByType, getProfileUrl } from "@/lib/urlHelpers";
import config from "@/config";
import { ViewStoriesSettings } from "@/types";
import { EVENTS } from "@/const";
import ChooseContentConfirm from "@/components/ChooseContentConfirm";
import InfiniteScroll from "@/components/InfiniteScroll/InfiniteScroll.vue";
import PromotedUserItem from "../PromotedUserItem";

export default defineComponent({
  name: "PromotedUserList",
  components: { ChooseContentConfirm, InfiniteScroll, PromotedUserItem },
  props: {
    list: { type: Array as () => UserPublicData[], required: true },
    enableScroll: { type: Boolean, required: true },
  },
  setup(_, { root }) {
    const storiesEnabled = computed(() => config.featureStories);
    const selectedCreator = ref<UserPublicData | null>(null);

    const handleShowStories = () => {
      if (!storiesEnabled.value || !selectedCreator.value) return;
      emitter.emit<ViewStoriesSettings>(EVENTS.STORIES_SHOW, {
        storyPublishers: [{ userId: selectedCreator.value.id, user: selectedCreator.value }],
        currentStoryId: selectedCreator.value.firstNotViewedStoryId || undefined,
      });
      selectedCreator.value = null;
    };

    const handleGoLive = () => {
      if (!selectedCreator.value) return;
      root.$router.push(getLiveUrlByType(selectedCreator.value));
    };

    const handleGoProfile = () => {
      if (!selectedCreator.value) return;
      root.$router.push(getProfileUrl(selectedCreator.value));
    };

    return {
      storiesEnabled,
      selectedCreator,
      handleShowStories,
      handleGoLive,
      handleGoProfile,
    };
  },
});
